var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState } from "react";
import productBouquetActions from "@redux/feature/Markets/NCD/actions/ProductBouquetActions";
import OrderBookActions from "@redux/feature/Markets/NCD/actions/OrderBookActions";
import { useSelector } from "react-redux";
import { removeEmptyObjects } from "@frameworks/NCD/Utils/removeEmptyObjects";
import { EOrderBookOrderBy } from "@frameworks/NCD/Enum/OTC";
import moment from "moment";
var useFilterActions = function (subCategoryId, isSingle, setSearchedClient) {
    var isOrderBook = location.pathname.toLowerCase().includes("orderbook");
    var _a = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }), watchListRequestPayload = _a.watchListRequestPayload, productLocalRatingFilters = _a.productLocalRatingFilters, productLocalCouponFilters = _a.productLocalCouponFilters, productLocalMaturityDateFilters = _a.productLocalMaturityDateFilters, productLocalTypeFilters = _a.productLocalTypeFilters, productLocalIssuerNameFilters = _a.productLocalIssuerNameFilters, productLocalPriceRangeFilters = _a.productLocalPriceRangeFilters, productLocalInterestFrequencyFilters = _a.productLocalInterestFrequencyFilters, productLocalMinInvestmentFilters = _a.productLocalMinInvestmentFilters, productLocalAvailableQuantityFilters = _a.productLocalAvailableQuantityFilters, productLocalProductTypeFilters = _a.productLocalProductTypeFilters, productLocalStatusFilters = _a.productLocalStatusFilters, productLocalClientNameFilters = _a.productLocalClientNameFilters, productLocalInvestmentValueFilters = _a.productLocalInvestmentValueFilters;
    var _b = useSelector(function (state) { return state.markets.Otc.orderBookReducer; }), orderBookNcdRequestPayload = _b.orderBookNcdRequestPayload, orderBookRequestPayload = _b.orderBookRequestPayload;
    var cProductBouquetActions = new productBouquetActions();
    var cOrderBookActions = new OrderBookActions();
    var _c = __read(useState(false), 2), isShowFilterPopup = _c[0], setIsShowFilterPopup = _c[1];
    var _d = __read(useState([]), 2), filterLabels = _d[0], setFilterLabels = _d[1];
    var clearSearching = function () { };
    var _e = __read(useState({}), 2), selectedValue = _e[0], setSelectedValue = _e[1];
    var handleUpdateFilterPopupState = function (state) {
        setIsShowFilterPopup(state);
        setSearchedClient && setSearchedClient("");
    };
    var handleRemoveThroughLabels = function (typeOfFilter, value) {
        setSearchedClient && setSearchedClient("");
        var payload = __assign({}, watchListRequestPayload);
        var orderBookPayload = __assign({}, orderBookRequestPayload);
        if (payload[typeOfFilter] || orderBookPayload[typeOfFilter]) {
            var updatedValues = filterLabels.filter(function (item) { return item.value !== value; });
            if (isOrderBook) {
                cOrderBookActions.getOrderBookNcdTable({});
                cOrderBookActions.getOrderBookTable({});
                orderBookPayload[typeOfFilter] =
                    !updatedValues || updatedValues.length === 0
                        ? ""
                        : updatedValues
                            .filter(function (item) {
                            return item.typeOfFilter === typeOfFilter;
                        })
                            .map(function (item) { return item.value; })
                            .join("##")
                            .replace(/##\s+/g, "##");
                var formatLabels = function (list, type) {
                    return (list || []).filter(function (item) { return item.value !== "all"; });
                };
                var newLabels = formatLabels(updatedValues, typeOfFilter);
                var allUpdatedLabels = __spreadArray([], __read(newLabels), false);
                setFilterLabels(__spreadArray([], __read(allUpdatedLabels), false));
                cOrderBookActions.setOrderBookRequestPayload(removeEmptyObjects(__assign(__assign({}, orderBookPayload), { subcategory_id: Number(subCategoryId) })));
            }
            else {
                payload[typeOfFilter] =
                    !updatedValues || updatedValues.length === 0
                        ? ""
                        : updatedValues
                            .filter(function (item) {
                            return item.typeOfFilter === typeOfFilter;
                        })
                            .map(function (item) { return item.value; })
                            .join("##")
                            .replace(/##\s+/g, "##");
                var formatLabels = function (list, type) {
                    return (list || []).filter(function (item) { return item.value !== "all"; });
                };
                var newLabels = formatLabels(updatedValues, typeOfFilter);
                var allUpdatedLabels = __spreadArray([], __read(newLabels), false);
                setFilterLabels(__spreadArray([], __read(allUpdatedLabels), false));
                cProductBouquetActions.updateWatchListRequestPayload(__assign({}, payload));
            }
            var data = updatedValues
                .filter(function (item) { return item.typeOfFilter === typeOfFilter; })
                .map(function (item) { return item.title; });
            switch (typeOfFilter) {
                case "rating":
                    cProductBouquetActions.getLocalProductRatingFilters(data);
                    break;
                case "issecured":
                    cProductBouquetActions.getLocalProductTypeFilters(data);
                    break;
                case "price_range":
                    cProductBouquetActions.getLocalProductPriceRangeFilters(data);
                    break;
                case "interest_frequency":
                    cProductBouquetActions.getLocalProductInterestFrequencyFilters(data);
                    break;
                case "Maturity_Date":
                    cProductBouquetActions.getLocalProductMaturityDateFilters(data);
                    break;
                case "issuer_name":
                    cProductBouquetActions.getLocalProductIssuerNameFilters(data);
                    break;
                case "coupon":
                    cProductBouquetActions.getLocalProductCouponFilters(data);
                    break;
                case "min_investment":
                    cProductBouquetActions.getLocalMinInvestmentFilters(data);
                    break;
                case "avl_qty":
                    cProductBouquetActions.getLocalAvailableQuantityFilters(data);
                    break;
                case "product_type":
                    cProductBouquetActions.getLocalProductTypesFilters(data);
                    break;
                case "status":
                    cProductBouquetActions.getLocalStatusFilters(data);
                    break;
                case "client_name":
                    cProductBouquetActions.getLocalClientNameFilters(data);
                    break;
                case "investment_value":
                    cProductBouquetActions.getLocalInvestmentValueFilters(data);
                    break;
                default:
                    console.warn("Unhandled typeOfFilter: ".concat(typeOfFilter));
                    break;
            }
        }
    };
    var handleSearch = function (searchText) {
        if (isOrderBook) {
            cOrderBookActions.getOrderBookNcdTable({});
            cOrderBookActions.getOrderBookTable({});
            var newPayload = __assign(__assign({}, orderBookRequestPayload), { category_code: Number(subCategoryId), page_index: 1, page_size: 10, orderby: EOrderBookOrderBy.TRXDATE, orderbydesc: true, search_key: searchText });
            cOrderBookActions.setOrderBookRequestPayload(removeEmptyObjects(newPayload));
        }
        else {
            var newPayload = __assign(__assign({}, watchListRequestPayload), { page_index: 1, page_size: 10, orderbydesc: false, orderby: "display_name", search_key: searchText });
            cProductBouquetActions.updateWatchListRequestPayload(newPayload);
        }
    };
    var handleClearAll = function () {
        setSearchedClient && setSearchedClient("");
        if (isOrderBook) {
            cOrderBookActions.getOrderBookNcdTable({});
            cOrderBookActions.getOrderBookTable({});
            cProductBouquetActions.resetFilterValue();
            setIsShowFilterPopup(false);
            setSelectedValue({});
            setFilterLabels([]);
            var newPayload = {
                category_code: Number(subCategoryId),
                page_index: 1,
                page_size: 10,
                orderby: EOrderBookOrderBy.TRXDATE,
                orderbydesc: true,
                from_date: moment().startOf("month").format("YYYY-MM-DD"),
                to_date: moment().format("YYYY-MM-DD"),
            };
            cOrderBookActions.setOrderBookRequestPayload(removeEmptyObjects(newPayload));
        }
        else {
            cProductBouquetActions.resetFilterValue();
            setIsShowFilterPopup(false);
            setSelectedValue({});
            setFilterLabels([]);
            var newPayload = {
                category_code: Number(watchListRequestPayload.category_code),
                tab_id: Number(watchListRequestPayload.tab_id),
                tab_value: watchListRequestPayload.tab_value,
                page_index: watchListRequestPayload.page_index,
                page_size: watchListRequestPayload.page_size,
                orderby: watchListRequestPayload.orderby,
                orderbydesc: watchListRequestPayload.orderbydesc,
                buysellflg: watchListRequestPayload.buysellflg,
            };
            cProductBouquetActions.updateWatchListRequestPayload(newPayload);
        }
    };
    var handleCancel = function () {
        setSearchedClient && setSearchedClient("");
        if (filterLabels.length > 0) {
            setIsShowFilterPopup(false);
        }
        else {
            cProductBouquetActions.resetFilterValue();
            setSelectedValue({});
            setFilterLabels([]);
            setIsShowFilterPopup(false);
        }
    };
    var handleApplyCallback = function () {
        var processFilter = function (filterArray) {
            return (filterArray === null || filterArray === void 0 ? void 0 : filterArray.filter(function (item) { return item !== "all"; }).join("## ").replace(/##\s+/g, "##")) || "";
        };
        var newPayload = __assign(__assign({}, watchListRequestPayload), { page_index: 1, page_size: 10, orderbydesc: false, orderby: "display_name", rating: processFilter(productLocalRatingFilters), coupon: processFilter(productLocalCouponFilters), Maturity_Date: processFilter(productLocalMaturityDateFilters), issecured: processFilter(productLocalTypeFilters), issuer_name: processFilter(productLocalIssuerNameFilters), price_range: processFilter(productLocalPriceRangeFilters), interest_frequency: processFilter(productLocalInterestFrequencyFilters), min_investment: processFilter(productLocalMinInvestmentFilters), avl_qty: processFilter(productLocalAvailableQuantityFilters) });
        cProductBouquetActions.updateWatchListRequestPayload(newPayload);
        var orderBookPayload = __assign(__assign({}, orderBookRequestPayload), { page_index: 1, page_size: 10, orderby: EOrderBookOrderBy.TRXDATE, orderbydesc: true, product_type: processFilter(productLocalProductTypeFilters), status: processFilter(productLocalStatusFilters), client_name: processFilter(productLocalClientNameFilters), investment_value: processFilter(productLocalInvestmentValueFilters) });
        if (isOrderBook) {
            cOrderBookActions.getOrderBookNcdTable({});
            cOrderBookActions.getOrderBookTable({});
            cOrderBookActions.setOrderBookRequestPayload(removeEmptyObjects(orderBookPayload));
        }
        var formatLabels = function (list, type) {
            return (list || [])
                .filter(function (item) { return item !== "all"; })
                .map(function (item) { return ({
                title: item,
                value: item,
                name: item,
                typeOfFilter: type,
            }); });
        };
        var allLabels = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(formatLabels(productLocalRatingFilters, "rating")), false), __read(formatLabels(productLocalCouponFilters, "coupon")), false), __read(formatLabels(productLocalMaturityDateFilters, "Maturity_Date")), false), __read(formatLabels(productLocalTypeFilters, "issecured")), false), __read(formatLabels(productLocalIssuerNameFilters, "issuer_name")), false), __read(formatLabels(productLocalPriceRangeFilters, "price_range")), false), __read(formatLabels(productLocalInterestFrequencyFilters, "interest_frequency")), false), __read(formatLabels(productLocalMinInvestmentFilters, "min_investment")), false), __read(formatLabels(productLocalProductTypeFilters, "product_type")), false), __read(formatLabels(productLocalStatusFilters, "status")), false), __read(formatLabels(productLocalClientNameFilters, "client_name")), false), __read(formatLabels(productLocalInvestmentValueFilters, "investment_value")), false);
        setIsShowFilterPopup(false);
        setFilterLabels(__spreadArray([], __read(allLabels), false));
    };
    var handleSortApplyFilters = function () {
        if (selectedValue) {
            var newPayload = __assign(__assign({}, watchListRequestPayload), { page_index: 1, page_size: 10, orderby: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.filterValue, orderbydesc: selectedValue === null || selectedValue === void 0 ? void 0 : selectedValue.type });
            cProductBouquetActions.updateWatchListRequestPayload(newPayload);
        }
        else {
            var newPayload = __assign(__assign({}, watchListRequestPayload), { page_index: 1, page_size: 10, orderbydesc: false, orderby: "display_name" });
            cProductBouquetActions.updateWatchListRequestPayload(newPayload);
        }
        setIsShowFilterPopup(false);
    };
    useEffect(function () {
        setSelectedValue({
            name: "Price Range per Qty. - High to Low",
            value: "price-range-desc",
            type: true,
            filterValue: "price_range",
        });
    }, []);
    var handleRadioChange = function (e, item) {
        setSelectedValue(item);
    };
    var handleUpdateDateFiltersData = function (data) {
        if (isSingle) {
            var filtersObject = __assign(__assign({}, orderBookNcdRequestPayload), { from_date: String(data.fromDate), to_date: String(data.toDate), page_index: 1, page_size: 10 });
            cOrderBookActions.getOrderBookNcdTable({});
            cOrderBookActions.getOrderBookTable({});
            cOrderBookActions.setOrderBookNcdRequestPayload(filtersObject);
        }
        else {
            var filtersObject = __assign(__assign({}, orderBookRequestPayload), { from_date: String(data.fromDate), to_date: String(data.toDate), page_index: 1, page_size: 10 });
            cOrderBookActions.getOrderBookNcdTable({});
            cOrderBookActions.getOrderBookTable({});
            cOrderBookActions.setOrderBookRequestPayload(filtersObject);
        }
    };
    return {
        isShowFilterPopup: isShowFilterPopup,
        clearSearching: clearSearching,
        handleUpdateFilterPopupState: handleUpdateFilterPopupState,
        handleRemoveThroughLabels: handleRemoveThroughLabels,
        handleSearch: handleSearch,
        handleClearAll: handleClearAll,
        handleApplyCallback: handleApplyCallback,
        filterLabels: filterLabels,
        handleSortApplyFilters: handleSortApplyFilters,
        selectedValue: selectedValue,
        handleRadioChange: handleRadioChange,
        setSelectedValue: setSelectedValue,
        handleUpdateDateFiltersData: handleUpdateDateFiltersData,
        handleCancel: handleCancel,
        setFilterLabels: setFilterLabels,
    };
};
export default useFilterActions;
